import React from "react";

function end() {
    return (
        <div>
            <h1>
                Thanks for participating in internal testing! You can now exit the tab.
            </h1>
        </div>
    );
}

export default end;